import { StaticI18nLink } from "../../Link.js";
import {
	DropdownItem as StyledDropdownItem,
	DropdownItemLink,
	DropdownItemLinkRaw,
} from "../styles/DropdownItem.styles.js";

const DropdownItem = ({
	children,
	onClick,
	href,
	target,
	rel,
	className,
	style,
	isExternal = false,
}) => {
	const handleClick = (e) => {
		if (onClick) {
			onClick(e);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			handleClick(e);
		}
	};

	// Se tem href e é externo, renderiza como link externo (sem StaticI18nLink)
	if (href && isExternal) {
		return (
			<DropdownItemLinkRaw
				href={href}
				target={target}
				rel={rel}
				onClick={handleClick}
				onKeyDown={handleKeyDown}
				className={className}
				style={style}
				role="menuitem"
				tabIndex={0}
			>
				{children}
			</DropdownItemLinkRaw>
		);
	}

	// Se tem href e é interno, usa StaticI18nLink.
	// passHref é obrigatório no Next 12: sem ele, o href NÃO chega ao filho
	// styled.a e o link renderiza <a> sem href (não crawlável, não abre em nova aba).
	if (href && !isExternal) {
		return (
			<StaticI18nLink href={href} passHref>
				<DropdownItemLinkRaw
					target={target}
					rel={rel}
					onClick={handleClick}
					onKeyDown={handleKeyDown}
					className={className}
					style={style}
					role="menuitem"
					tabIndex={0}
				>
					{children}
				</DropdownItemLinkRaw>
			</StaticI18nLink>
		);
	}

	// Caso contrário, renderiza como botão
	return (
		<StyledDropdownItem
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			className={className}
			style={style}
			role="menuitem"
			tabIndex={0}
			type="button"
		>
			{children}
		</StyledDropdownItem>
	);
};

export default DropdownItem;
